/* PDP STORY (parity ducha): si el landing está embebido, forzar scroll de documento normal — el theme deja
   html como scroll-container de altura fija (overflow:auto !important) y eso rompe position:sticky
   de STACK/DISECCIÓN. Self-guarded: solo corre cuando hay #agc-landing en la página. */
(function(){ if(document.getElementById('agc-landing')){ var d=document.documentElement,b=document.body;
  d.style.setProperty('overflow','visible','important'); d.style.setProperty('height','auto','important');
  b.style.setProperty('overflow','visible','important'); b.style.setProperty('height','auto','important'); } })();
/* ============================================================
   AGC CONFIGURATOR JS — iyO-inspired PDP (Fase 1)
   Datos reales via window.AGC_CFG (inyectado por la sección Liquid).
   Carrito real: /cart/add.js + cart-drawer.renderContents() del theme.
   Mapping (FASE0-GROUND-TRUTH.md):
     tier  = quantity del variant elegido
     color = variant_id
     plan  = selling_plan (siempre — subscription-only)
     +Set Anual = línea one-time extra
     descuento tier = automatic discount Shopify (no requiere código)
   ============================================================ */
(function () {
  'use strict';
  var CFG = window.AGC_CFG;
  if (!CFG) return;
  var root = document.getElementById('agc-cfg');
  if (!root) return;

  var $ = function (sel) { return root.querySelector(sel); };
  var $$ = function (sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); };
  var fmt = function (cents) { return '$' + Math.round(cents / 100).toString(); };

  /* El video frame-scrub NO se tinta por color (decisión Pedro 2026-06-12):
     cada acabado tendrá su propio set de frames más adelante. El cambio de
     color solo actualiza variante, precio y thumb (foto real del acabado). */
  var state = { freq: 3, planId: null, colorKey: 'filtro', anual: false, busy: false, step: 'config', qty: 1, plus: true };  /* v2 2026-09-23: qty = baños (1 filtro por regadera), plus = switch Aguacero Plus+ */

  /* único "color" = el filtro (variante única del producto de reemplazo) */
  var firstAvail = CFG.colors.filter(function (c) { return c.available; })[0] || CFG.colors[0];
  state.colorKey = firstAvail.key;

  function colorByKey(k) {
    for (var i = 0; i < CFG.colors.length; i++) if (CFG.colors[i].key === k) return CFG.colors[i];
    return CFG.colors[0];
  }

  /* ── selling plans por frecuencia (cada 1/2/3 meses) ──
     Detecta los meses del nombre del plan Recharge y mapea freq → selling_plan id. */
  var PLANS = {}; /* { 1: id, 2: id, 3: id } */
  (function buildPlans() {
    var raw = CFG.freqPlans || [];
    raw.forEach(function (p) {
      var nm = String(p.name || '');
      var m = nm.match(/(\d+)\s*mes/i);          /* "cada 3 meses" / "cada 2 meses" */
      var months = m ? parseInt(m[1], 10)
                     : (/cada\s+mes|al\s+mes|mensual/i.test(nm) ? 1 : null); /* "cada mes" = 1 */
      if (months && !PLANS[months]) PLANS[months] = p.id;
    });
    /* fallback: si no se pudo parsear, asigna en orden recibido a 3,2,1 */
    if (!Object.keys(PLANS).length && raw.length) {
      [3, 2, 1].forEach(function (mo, i) { if (raw[i]) PLANS[mo] = raw[i].id; });
    }
    /* default = 3 meses si existe, si no el mayor disponible */
    var avail = Object.keys(PLANS).map(Number).sort(function (a, b) { return b - a; });
    if (avail.indexOf(3) === -1 && avail.length) state.freq = avail[0];
    state.planId = PLANS[state.freq] || CFG.sellingPlanId || null;
  })();

  /* ── pricing: $590 fijo en las 3 frecuencias (regla Pedro) — sin descuento por tier ── */
  function totals() {
    var base = colorByKey(state.colorKey).price * state.qty; /* centavos, precio lista del filtro × baños */
    return { today: base, gross: base, renew: base };
  }

  /* ── showroom escena 0: filmstrip ancho derivando (2 copias seamless) + tinte ── */
  var strip = $('#agcStrip');
  var stripBuilt = {};
  /* drift JS-driven (auto-drift + swipe manual) · 3 copias = loop infinito seamless bidireccional */
  var COPIES = 3;
  var heroOffset = 0, heroCopyW = 0, heroDragging = false, heroResumeAt = 0, heroInit = false, heroFling = 0;
  function buildStrip(key) {
    if (!strip) return;
    var src = (CFG.heroStrips && CFG.heroStrips[key]);
    if (!src) return;
    strip.innerHTML = '';
    heroCopyW = 0; heroInit = false; /* recalcular tras swap de color */
    for (var i = 0; i < COPIES; i++) {
      var im = document.createElement('img');
      im.src = src;
      im.alt = '';
      im.loading = 'eager'; /* misma URL → cacheada; deben tener ancho para el loop */
      if (key === firstAvail.key && i === 0) im.fetchPriority = 'high';
      strip.appendChild(im);
    }
    stripBuilt[key] = true;
  }
  function heroDrift() {
    if (strip) {
      if (!heroCopyW && strip.scrollWidth > 0) heroCopyW = strip.scrollWidth / COPIES;
      if (heroCopyW && !heroInit) { heroOffset = -heroCopyW; heroInit = true; } /* centra en copia media */
      var now = (window.performance && performance.now) ? performance.now() : Date.now();
      if (!heroDragging) {
        if (Math.abs(heroFling) > 0.15) { heroOffset += heroFling; heroFling *= 0.94; } /* INERCIA: glide tras soltar el swipe, desacelera suave */
        else if (now > heroResumeAt && heroCopyW) heroOffset -= heroCopyW / 2568; /* auto-drift */
      }
      if (heroCopyW) { /* mantener offset en [-2W, -W): copia media siempre llena, buffer a ambos lados */
        while (heroOffset <= -2 * heroCopyW) heroOffset += heroCopyW;
        while (heroOffset > -heroCopyW) heroOffset -= heroCopyW;
      }
      strip.style.transform = 'translateX(' + heroOffset + 'px)';
    }
    requestAnimationFrame(heroDrift);
  }
  requestAnimationFrame(heroDrift);
  /* precarga los 4 strips (mismas dimensiones) para que el swap de color sea instantáneo */
  (window.requestIdleCallback || function (f) { setTimeout(f, 1500); })(function () {
    if (!CFG.heroStrips) return;
    Object.keys(CFG.heroStrips).forEach(function (k) { var p = new Image(); p.src = CFG.heroStrips[k]; });
  });
  function setHeroColor(key) {
    $$('.agc-htint').forEach(function (t) { t.classList.toggle('on', t.classList.contains('h-' + key)); });
    if (!strip) return;
    var src = (CFG.heroStrips && CFG.heroStrips[key]);
    if (!src) return;
    var imgs = strip.querySelectorAll('img');
    if (!imgs.length) { buildStrip(key); return; }
    /* swap de src EN SITIO — layout idéntico → la animación NO se reinicia, solo cambia el color */
    for (var i = 0; i < imgs.length; i++) { if (imgs[i].getAttribute('src') !== src) imgs[i].src = src; }
  }

  /* ── render ── */
  function syncThumb() {
    var c = colorByKey(state.colorKey);
    var img = $('#agcThumbImg');
    if (img && c.img && img.getAttribute('src') !== c.img) img.src = c.img;   /* colapsado: mirror ducha */
    var vid = $('#agcThumbVid');
    if (vid) {                                                                /* expandido: bola del material */
      var url = (CFG.swatches && CFG.swatches[state.colorKey]) || '';
      if (url && vid.getAttribute('src') !== url) { vid.src = url; var p = vid.play(); if (p && p.catch) p.catch(function () {}); }
    }
    $$('.agc-sw').forEach(function (x) { x.classList.toggle('on', x.dataset.c === state.colorKey); });
  }
  function freqLabel(n) { return 'Cada ' + n + (n === 1 ? ' mes' : ' meses'); }
  function render() {
    var t = totals();
    var sep = '<span class="sep">/</span>';
    var cfgEl = $('#agcCfgText');
    var nf = state.qty + (state.qty === 1 ? ' filtro' : ' filtros');
    if (cfgEl) cfgEl.innerHTML = nf + ' ' + sep + ' ' + (state.plus ? freqLabel(3) + ' ' + sep + ' Aguacero Plus+' : 'Compra única');
    var headPrice = $('#agcHeadPrice'); if (headPrice) headPrice.textContent = fmt(t.today);
    var payBig = $('#agcPayBig'), renewBig = $('#agcRenewBig');
    if (payBig) payBig.textContent = fmt(t.today);
    if (renewBig) renewBig.textContent = fmt(t.renew);
    var fn = $('#agcFreqName'); if (fn) fn.textContent = freqLabel(state.freq);
    var ctaPrice = $('#agcCtaPrice');
    if (ctaPrice) ctaPrice.textContent = fmt(t.today);
    /* deal card — precio fijo $590, sub refleja la frecuencia elegida */
    var dt = $('#agcDealTitle'); if (dt) dt.textContent = 'Filtro de Reemplazo A-0';
    var ds = $('#agcDealSub'); if (ds) ds.textContent = '+ Llega automático ' + freqLabel(state.freq).toLowerCase();
    var dnow = $('#agcDealNow'); if (dnow) dnow.textContent = fmt(t.today);
    var dcu = $('#agcDealCu'); if (dcu) dcu.textContent = '';
    var dwas = $('#agcDealWas'); if (dwas) dwas.textContent = '';
    if (dt && state.qty > 1) dt.textContent = 'Filtro de Reemplazo A-0 ×' + state.qty;
    /* switch Aguacero Plus+ (snippet agc-sub-switch, mismo de la ducha) */
    var swT = document.getElementById('agcSubSwT'), swN = document.getElementById('agcSubSwNote');
    if (swT) swT.textContent = 'Cada 3 meses';
    if (swN) swN.innerHTML = state.plus ? (state.qty > 1 ? state.qty + ' filtros nuevos' : 'Filtro nuevo') + ' por ' + fmt(t.renew) + '<br>Pausa o cancela cuando quieras' : 'Compra única, sin envíos automáticos';
    var totLb = $('#agcTotLb'), totAmt = $('#agcTotalAmt');
    if (totLb) totLb.textContent = 'Total (' + state.qty + ')';
    if (totAmt) totAmt.textContent = fmt(t.today);
  }

  /* ── coreografía scroll + frame-scrub ── */
  var scroller = $('#agcScroller');
  var prod = $('#agcProd');
  var floor = $('#agcFloor');
  var frameImg = $('#agcFrame');
  var envs = [$('#agcE0'), $('#agcE1'), $('#agcE2'), $('#agcE3'), $('#agcE4')];
  var spot = $('#agcSpot');
  var dots = $$('.agc-dots b');
  var scenes = $$('.agc-scene');
  /* 6 escenas: 0=showroom (sin producto-video), 1=hero texto, 2=problema, 3=mecanismo, 4=prueba, 5=oferta */
  var ST = [
    { x: 0, y: 22, s: 1.12, r: -8 },
    { x: 0, y: 22, s: 1.12, r: -8 },
    { x: 78, y: -6, s: 0.8, r: 7 },
    { x: 0, y: -18, s: 1.62, r: 0 },
    { x: -74, y: -4, s: 0.72, r: -7 },
    { x: 0, y: 18, s: 0.62, r: 0 }
  ];
  var NS = 5; /* índice máximo de escena (0..5) */
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var cl = function (v, a, b) { return Math.max(a, Math.min(b, v)); };

  /* frames: primeros 40 eager, resto en idle — total ~4MB */
  var NF = CFG.frameCount, FR = [];
  function frameUrl(n) { return CFG.frameBase.replace('001', String(n).padStart(3, '0')); }
  for (var n = 1; n <= NF; n++) FR.push(frameUrl(n));
  var preloaded = 0;
  var framesVisible = getComputedStyle($('#agcProdstage')).display !== 'none';
  function preload(upTo) {
    if (!framesVisible) return;
    while (preloaded < upTo && preloaded < NF) { var im = new Image(); im.src = FR[preloaded]; preloaded++; }
  }
  /* SPEED (2026-07-02): los frames NO compiten con el LCP. En 4G el idle disparaba ~3.3MB
     al boot (requestIdleCallback = CPU libre, no red libre) y ahogaba el pipe del LCP.
     40 frames al primer gesto (intención de scrubbing) o post-load idle; los 182 solo tras load+idle.
     El scrub es on-demand (frameImg.src=FR[fi]) → sin precarga igual funciona. */
  var _fBoot = false;
  function preloadBoot() { if (_fBoot) return; _fBoot = true; preload(40); }
  ['pointerdown', 'touchstart', 'scroll', 'wheel'].forEach(function (ev) { window.addEventListener(ev, preloadBoot, { once: true, passive: true }); });
  function _afterLoad(f) { if (document.readyState === 'complete') { f(); } else { window.addEventListener('load', f, { once: true }); } }
  _afterLoad(function () {
    (window.requestIdleCallback || function (f) { setTimeout(f, 800); })(function () { preloadBoot(); preload(NF); });
  });

  var lastIdx = -1, lastScroll = -1;
  var showroom = $('#agcShowroom'), heroEnv = $('#agcHeroEnv'), prodstage = $('#agcProdstage'), colorPillEl = $('#agcColorPill');
  var pillHeroVis = 1;
  function tick() {
    var H = scroller.clientHeight || 1;
    var top = scroller.scrollTop;
    if (top !== lastScroll) {
      lastScroll = top;
      /* fuera de la primera pantalla (scene 0) → la card colapsa a solo-footer + se ocultan colores/3D toggle */
      root.classList.toggle('scrolled', top > H * 0.5);
      var p = cl(top / H, 0, NS);
      /* handoff de capas: escena 0 = showroom puro; escenas 1+ = narrativa con video */
      var heroVis = cl(1 - p * 1.6, 0, 1);
      var videoVis = cl((p - 0.45) * 1.9, 0, 1);
      if (showroom) {
        showroom.style.opacity = heroVis;
        showroom.style.transform = 'translateY(' + (-p * 90) + 'px)';
        showroom.style.visibility = heroVis === 0 ? 'hidden' : 'visible';
      }
      pillHeroVis = heroVis;
      if (heroEnv) heroEnv.style.opacity = heroVis;
      if (prodstage) prodstage.style.opacity = videoVis;
      var i = Math.min(ST.length - 2, Math.floor(p)), t = p - i;
      var a = ST[i], b = ST[i + 1] || ST[i];
      prod.style.setProperty('--x', lerp(a.x, b.x, t) + 'px');
      prod.style.setProperty('--y', lerp(a.y, b.y, t) + 'px');
      prod.style.setProperty('--s', lerp(a.s, b.s, t));
      prod.style.setProperty('--r', lerp(a.r, b.r, t) + 'deg');
      floor.style.setProperty('--x', lerp(a.x, b.x, t) + 'px');
      floor.style.setProperty('--y', lerp(a.y, b.y, t) + 'px');
      floor.style.setProperty('--s', lerp(a.s, b.s, t));
      floor.style.opacity = cl(1 - Math.abs(p - 3), 0.15, 1) * videoVis;
      /* el video arranca fresco en la escena 1 (hero texto) y recorre su arco hasta la 5 */
      var vp = cl((p - 1) / (NS - 1), 0, 1);
      var fi = Math.min(NF - 1, Math.max(0, Math.round(vp * (NF - 1))));
      if (fi !== lastIdx) { if (framesVisible) frameImg.src = FR[fi]; lastIdx = fi; }
      /* envs e0..e4 acompañan las escenas narrativas 1..5 */
      envs.forEach(function (e, k) { if (e) e.style.opacity = cl(1 - Math.abs(p - (k + 1)), 0, 1); });
      if (spot) spot.style.opacity = cl(1 - Math.abs(p - 3) * 0.7, 0.2, 1);
      var cur = Math.round(p);
      dots.forEach(function (d, k) { d.classList.toggle('on', k === cur); });
    }
    /* SIEMPRE (fuera del guard de scroll): el pill se oculta con menú/isla abiertos, sin depender de scroll */
    if (colorPillEl) {
      var pillVis = ((island && island.classList.contains('open')) || (nav && nav.classList.contains('open')) || document.documentElement.classList.contains('agcn-open')) ? 0 : pillHeroVis;
      colorPillEl.style.opacity = pillVis;
      colorPillEl.style.pointerEvents = pillVis > 0.5 ? 'auto' : 'none';
    }
    requestAnimationFrame(tick);
  }
  requestAnimationFrame(tick);

  /* ── swipe horizontal del showroom con INERCIA estilo iyO (solo escena 0) ── */
  var hgStartX = 0, hgStartY = 0, hgStartOffset = 0, hgDir = null, hgLastX = 0, hgVel = 0;
  function onScene0() { return scroller.scrollTop < scroller.clientHeight * 0.5; }
  scroller.addEventListener('touchstart', function (e) {
    if (!onScene0()) return;
    var t = e.touches[0];
    hgStartX = t.clientX; hgStartY = t.clientY; hgStartOffset = heroOffset; hgDir = null;
    hgLastX = t.clientX; hgVel = 0; heroFling = 0; /* agarrar la imagen detiene la inercia previa */
  }, { passive: true });
  scroller.addEventListener('touchmove', function (e) {
    if (!onScene0() || hgDir === 'v') return;
    var t = e.touches[0];
    var dx = t.clientX - hgStartX, dy = t.clientY - hgStartY;
    if (hgDir === null && (Math.abs(dx) > 7 || Math.abs(dy) > 7)) {
      hgDir = Math.abs(dx) > Math.abs(dy) * 1.2 ? 'h' : 'v';
    }
    if (hgDir === 'h') {
      e.preventDefault();              /* el swipe horizontal no dispara el scroll vertical */
      heroDragging = true;
      heroOffset = hgStartOffset + dx;
      hgVel = (t.clientX - hgLastX) * 0.55 + hgVel * 0.45; /* velocidad suavizada (px/frame) */
      hgLastX = t.clientX;
    }
  }, { passive: false });
  function endHeroDrag() {
    if (hgDir === 'h') {
      heroFling = hgVel;               /* lanza con la velocidad del swipe → glide con inercia */
      heroResumeAt = ((window.performance && performance.now) ? performance.now() : Date.now()) + 1600;
    }
    hgDir = null; heroDragging = false;
  }
  scroller.addEventListener('touchend', endHeroDrag, { passive: true });
  scroller.addEventListener('touchcancel', endHeroDrag, { passive: true });

  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) e.target.classList.add('show'); });
  }, { root: scroller, threshold: 0.55 });
  scenes.forEach(function (s) { io.observe(s); });

  /* ── menú bento (morph del nav pill, patrón iyO) ── */
  var nav = $('#agcNav'), navBg = $('#agcNavBg');
  var cycleTimer = null, cycleIdx = 0;
  function startCycle() {
    var imgs = $$('#agcMenuCycle img');
    if (!imgs.length || cycleTimer) return;
    cycleTimer = setInterval(function () {
      imgs[cycleIdx].classList.remove('on');
      cycleIdx = (cycleIdx + 1) % imgs.length;
      imgs[cycleIdx].classList.add('on');
    }, 2600);
  }
  function stopCycle() {
    if (cycleTimer) { clearInterval(cycleTimer); cycleTimer = null; }
  }
  function closeMenu() {
    if (window.AGCNav) window.AGCNav.close();   /* barra compartida agc-nav */
    if (nav) nav.classList.remove('open');
    if (navBg) navBg.classList.remove('show');
    root.classList.remove('menu-open');
    stopCycle();
  }
  /* la barra compartida avisa al abrir → cerramos la isla de config (comportamiento original) */
  document.addEventListener('agcn:toggle', function (e) { if (e.detail && e.detail.open) setIsland(false); });
  var menuBtn = $('#agcMenuBtn');
  if (menuBtn) menuBtn.addEventListener('click', function () {
    var willOpen = !nav.classList.contains('open');
    if (willOpen) setIsland(false);
    nav.classList.toggle('open', willOpen);
    navBg.classList.toggle('show', willOpen);
    root.classList.toggle('menu-open', willOpen);
    if (willOpen) startCycle(); else stopCycle();
  });
  if (navBg) navBg.addEventListener('click', closeMenu);

  /* ── reseñas: widget glass propio (datos de la BD) + vista Loox con fotos ── */
  var revOverlay = $('#agcReviewsOverlay');
  var REVIEWS = null, revShown = 0, revPhotosMode = false;
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  function fmtRevDate(d) {
    if (!d) return '';
    var p = d.split('-');
    return parseInt(p[2], 10) + ' ' + (MESES[parseInt(p[1], 10) - 1] || '') + ' ' + p[0];
  }
  function revCard(rv) {
    var el = document.createElement('div');
    el.className = 'agc-revcard' + (rv.img ? ' has-img' : '');
    var stars = '★★★★★'.slice(0, rv.r) + '<span class="off">' + '★★★★★'.slice(rv.r) + '</span>';
    el.innerHTML =
      (rv.img ? '<div class="rc-img"><img loading="lazy" alt=""></div>' : '') +
      '<div class="rc-body">' +
      '<div class="rc-head"><span class="rc-name"></span>' +
      (rv.src === 'ml' ? '<span class="rc-verified rc-ml"><img src="' + CFG.reviewsUrl.replace(/agc-reviews\.json.*$/, 'agc-ml-logo.png') + '" alt="Mercado Libre" width="14" height="10" loading="lazy">Compra verificada</span>' : rv.v ? '<span class="rc-verified">✓ Verificada</span>' : '') + '</div>' +
      '<div class="rc-meta"><span class="rc-stars">' + stars + '</span><span class="rc-date">' + fmtRevDate(rv.d) + '</span></div>' +
      '<p class="rc-text"></p></div>';
    if (rv.img) el.querySelector('.rc-img img').src = rv.img;
    el.querySelector('.rc-name').textContent = rv.n;
    el.querySelector('.rc-text').textContent = rv.t;
    return el;
  }
  var revFilter = 'all'; /* Todas / Con fotos / Sin fotos (Pedro 2026-07-14) */
  function revFiltered() {
    if (!REVIEWS) return [];
    if (revFilter === 'img') return REVIEWS.filter(function (r) { return !!r.img; });
    if (revFilter === 'txt') return REVIEWS.filter(function (r) { return !r.img; });
    return REVIEWS;
  }
  function renderRevBatch() {
    var grid = $('#agcRevGrid');
    if (!grid || !REVIEWS) return;
    var list = revFiltered();
    var frag = document.createDocumentFragment();
    list.slice(revShown, revShown + 12).forEach(function (rv) { frag.appendChild(revCard(rv)); });
    revShown = Math.min(revShown + 12, list.length);
    grid.appendChild(frag);
    var more = $('#agcRevMore');
    if (more) more.style.display = revShown >= list.length ? 'none' : '';
  }
  var revFilterBar = $('#agcRevFilter');
  if (revFilterBar) revFilterBar.addEventListener('click', function (e) {
    var b = e.target.closest('[data-revf]');
    if (!b || b.classList.contains('on')) return;
    revFilter = b.getAttribute('data-revf');
    revFilterBar.querySelectorAll('.agc-revf-btn').forEach(function (x) { x.classList.toggle('on', x === b); });
    var grid = $('#agcRevGrid');
    if (grid) grid.innerHTML = '';
    revShown = 0;
    renderRevBatch();
  });
  function loadReviews() {
    if (REVIEWS) return;
    fetch(CFG.reviewsUrl).then(function (r) { return r.json(); }).then(function (d) {
      REVIEWS = d;
      renderRevBatch();
    }).catch(function () {
      /* sin datos: caer a la vista Loox */
      setPhotosMode(true);
    });
  }
  function setPhotosMode(on) {
    revPhotosMode = on;
    var sheet = revOverlay ? revOverlay.querySelector('.agc-reviews-sheet') : null;
    if (sheet) sheet.classList.toggle('photos', on);
    var btn = $('#agcRevPhotos');
    if (btn) btn.textContent = on ? '← Volver a reseñas' : 'Ver reseñas con fotos →';
  }
  function openReviews() {
    closeMenu();
    setIsland(false);
    if (revOverlay) revOverlay.classList.add('show');
    document.documentElement.classList.add('agc-sheet'); /* esconde la barra compartida */
    loadReviews();
  }
  function closeReviews() { if (revOverlay) revOverlay.classList.remove('show'); document.documentElement.classList.remove('agc-sheet'); }
  var revMore = $('#agcRevMore');
  if (revMore) revMore.addEventListener('click', renderRevBatch);
  var revWrite = $('#agcRevWrite');
  if (revWrite) revWrite.addEventListener('click', function () {
    if (window.LOOX && typeof window.LOOX.showReviewForm === 'function') { try { window.LOOX.showReviewForm(); return; } catch (e) {} }
    setPhotosMode(true);
  });
  var revBtn = $('#agcReviewsBtn');
  if (revBtn) revBtn.addEventListener('click', openReviews);
  var menuRev = $('#agcMenuReviews');
  if (menuRev) menuRev.addEventListener('click', openReviews);
  var headRev = $('#agcHeadReviews');
  if (headRev) headRev.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
  /* 3 islas (port de la ducha) — Vela en acción → modal video (#agcVideoModal de theme.liquid); Ver reseñas → widget (Pedro 2026-06-22) */
  var velaIsle = $('#agcVelaIsle');
  if (velaIsle) velaIsle.addEventListener('click', function () {
    var m = document.getElementById('agcVideoModal'), p = document.getElementById('agcVideoPlayer');
    if (m) { m.classList.add('active'); document.body.style.overflow = 'hidden'; }
    if (p) { try { p.currentTime = 0; p.play(); } catch (e) {} }
  });
  var revIsle = $('#agcReviewsIsle');
  if (revIsle) revIsle.addEventListener('click', function (e) { e.stopPropagation(); openReviews(); });
  var revClose = $('#agcReviewsClose');
  if (revClose) revClose.addEventListener('click', closeReviews);
  if (revOverlay) revOverlay.addEventListener('click', function (e) { if (e.target === revOverlay) closeReviews(); });

  /* ── hoja de objeciones: Chat (AI shell) ── */
  var askOverlay = $('#agcAskOverlay');
  var OBJ = [];
  try { var od = document.getElementById('agcObjData'); OBJ = od ? JSON.parse(od.textContent) : []; } catch (e) { OBJ = []; }
  var askChat = $('#agcAskChat');
  var typeTimer = null;

  /* v2 (parity ducha 2026-07-02): FAQ-first + scroll-lock iOS-proof + Esc + swipe-down; chat on-demand */
  var lockY = 0;
  function lockScroll(on) {
    var de = document.documentElement.style, bs = document.body.style;
    if (on) {
      lockY = window.scrollY || window.pageYOffset || 0;
      de.overflow = 'hidden';
      bs.position = 'fixed'; bs.top = (-lockY) + 'px'; bs.left = '0'; bs.right = '0'; bs.width = '100%'; bs.overflow = 'hidden';
    } else {
      de.overflow = '';
      bs.position = ''; bs.top = ''; bs.left = ''; bs.right = ''; bs.width = ''; bs.overflow = '';
      window.scrollTo(0, lockY);
    }
  }
  function openAsk() { closeMenu(); setIsland(false); if (askOverlay) askOverlay.classList.add('show'); document.documentElement.classList.add('agc-sheet'); lockScroll(true); var b = $('#agcDudasBody'); if (b) b.classList.remove('chat-on'); var v = $('#agcAskVariants'); if (v) v.hidden = true; }
  function closeAsk() { if (askOverlay) askOverlay.classList.remove('show'); document.documentElement.classList.remove('agc-sheet'); lockScroll(false); if (typeTimer) { clearInterval(typeTimer); typeTimer = null; } }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && askOverlay && askOverlay.classList.contains('show')) closeAsk(); });
  (function () {
    var sheet = askOverlay && askOverlay.querySelector('.agc-ask-sheet'); if (!sheet) return;
    var y0 = null, dy = 0;
    [sheet.querySelector('.agc-ask-grab'), sheet.querySelector('.agc-ask-top')].forEach(function (z) {
      if (!z) return;
      z.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; dy = 0; sheet.style.transition = 'none'; }, { passive: true });
      z.addEventListener('touchmove', function (e) { if (y0 === null) return; dy = Math.max(0, e.touches[0].clientY - y0); sheet.style.transform = 'translateY(' + dy + 'px)'; }, { passive: true });
      z.addEventListener('touchend', function () { sheet.style.transition = ''; sheet.style.transform = ''; if (dy > 70) closeAsk(); y0 = null; dy = 0; });
    });
  })();
  /* accordion FAQ (un item abierto a la vez) */
  var faqWrap = $('#agcDudasFaq');
  if (faqWrap) faqWrap.addEventListener('click', function (e) {
    var q = e.target.closest('.agc-faq-q'); if (!q) return;
    var item = q.parentElement, wasOpen = item.classList.contains('open');
    faqWrap.querySelectorAll('.agc-faq-item.open').forEach(function (x) { x.classList.remove('open'); });
    if (!wasOpen) item.classList.add('open');
  });
  var dudasChat = $('#agcDudasChat');
  if (dudasChat) dudasChat.addEventListener('click', function () {
    var b = $('#agcDudasBody'), v = $('#agcAskVariants');
    if (v) v.hidden = false;
    if (b) b.classList.add('chat-on');
    buildChat();
  });
  var dudasGo = $('#agcDudasGo'); if (dudasGo) dudasGo.addEventListener('click', function () { closeAsk(); setMode('config'); });
  var askBtn = $('#agcAskBtn'); if (askBtn) askBtn.addEventListener('click', openAsk);
  var askClose = $('#agcAskClose'); if (askClose) askClose.addEventListener('click', closeAsk);
  if (askOverlay) askOverlay.addEventListener('click', function (e) { if (e.target === askOverlay) closeAsk(); });

  /* — CHAT — */
  function scrollChat(log) { if (log) log.scrollTop = log.scrollHeight; }
  function typeText(el, text, log) {
    if (typeTimer) clearInterval(typeTimer);
    var words = text.split(' '), n = 0;
    typeTimer = setInterval(function () {
      el.textContent = words.slice(0, n + 1).join(' '); n++; scrollChat(log);
      if (n >= words.length) { clearInterval(typeTimer); typeTimer = null; }
    }, 38);
  }
  function chatAsk(i, chipEl) {
    var o = OBJ[i]; if (!o) return;
    var log = $('#agcChatLog'); if (!log) return;
    var u = document.createElement('div'); u.className = 'agc-msg agc-msg-user';
    u.innerHTML = '<div class="agc-bubble"></div>'; u.querySelector('.agc-bubble').textContent = o.q;
    log.appendChild(u);
    if (chipEl) chipEl.classList.add('used');
    var chipsWrap = $('#agcChatChips');
    if (chipsWrap && !chipsWrap.querySelector('.agc-chatchip:not(.used)')) {
      chipsWrap.innerHTML = '<button type="button" class="agc-chat-done" id="agcChatDone">Volver y elegir mi Aguacero →</button>';
      var cb = $('#agcChatDone'); if (cb) cb.addEventListener('click', closeAsk);
    }
    var b = document.createElement('div'); b.className = 'agc-msg agc-msg-bot';
    b.innerHTML = '<div class="agc-msg-av">🌊</div><div class="agc-bubble"><span class="agc-typing"><i></i><i></i><i></i></span></div>';
    log.appendChild(b); scrollChat(log);
    setTimeout(function () { var bub = b.querySelector('.agc-bubble'); bub.textContent = ''; typeText(bub, o.a, log); }, 620);
  }
  function buildChat() {
    if (!askChat) return;
    if (typeTimer) { clearInterval(typeTimer); typeTimer = null; }
    var chips = OBJ.map(function (o, i) { return '<button class="agc-chatchip" data-i="' + i + '" type="button">' + o.c + '</button>'; }).join('');
    askChat.innerHTML =
      '<div class="agc-chat-log" id="agcChatLog">' +
        '<div class="agc-msg agc-msg-bot"><div class="agc-msg-av">🌊</div><div class="agc-bubble">Hola 👋 ¿Qué te gustaría saber antes de tu Aguacero?</div></div>' +
      '</div>' +
      '<div class="agc-chat-chips" id="agcChatChips"><span class="agc-chat-chiplbl">Toca una pregunta</span>' + chips + '</div>';
    askChat.querySelectorAll('.agc-chatchip').forEach(function (c) {
      c.addEventListener('click', function () { chatAsk(parseInt(c.getAttribute('data-i'), 10), c); });
    });
  }

  /* ── ticker de confianza arriba del CTA (auto-scroll vertical infinito) ── */
  (function () {
    var track = document.querySelector('#agcEta .agc-eta-track');
    if (!track || track.children.length < 2) return;
    var n = track.children.length;        /* incluye el duplicado del 1ro al final para loop seamless */
    var h = track.children[0].offsetHeight || 14;
    var idx = 0, EASE = 'transform .6s cubic-bezier(.65,0,.35,1)';
    setInterval(function () {
      idx++;
      track.style.transition = EASE;
      track.style.transform = 'translateY(' + (-idx * h) + 'px)';
      if (idx >= n - 1) {
        setTimeout(function () {
          track.style.transition = 'none';
          track.style.transform = 'translateY(0)';
          idx = 0;
        }, 620);
      }
    }, 3200);
  })();

  /* ── módulos flotantes DESKTOP: carrusel de reseñas (izq) + verdad minimal (arriba-der) ── */
  (function () {
    if (!document.querySelector('#agcDeskFloat')) return;
    var rail = $('#agcDfRevRail'), nextBtn = $('#agcDfRevNext'), mVerdad = $('#agcDfVerdad');
    var VERDAD = [];
    try { var vd = document.getElementById('agcVerdadData'); VERDAD = vd ? JSON.parse(vd.textContent) : []; } catch (e) { VERDAD = []; }

    /* RESEÑAS — carrusel INFINITO: todas las de Loox (imágenes primero), solo la izquierda se lee */
    var revPool = [], STEP = 316, revAnimating = false; /* card 300 + gap 16 */
    function buildRevCards(arr) {
      var ok = arr.filter(function (r) { return r.t && r.t.length > 20 && r.t.length < 240; });
      var withImg = ok.filter(function (r) { return !!r.img; });
      var noImg = ok.filter(function (r) { return !r.img; });
      revPool = withImg.concat(noImg); /* todas las con imagen primero, luego el resto (fondo sólido = sin perf hit) */
      if (!revPool.length) revPool = arr.slice();
      if (!rail) return;
      rail.innerHTML = '';
      revPool.forEach(function (rv) {
        var stars = '★★★★★'.slice(0, rv.r || 5);
        var card = document.createElement('div'); card.className = 'dfrev-card';
        card.innerHTML = '<div class="dfrev-top">' + (rv.img ? '<img class="dfrev-img" src="' + rv.img + '" alt="" loading="lazy">' : '') +
          '<div class="dfrev-id"><span class="dfrev-stars">' + stars + '</span><span class="dfrev-name"></span></div></div>' +
          '<p class="dfrev-text"></p>';
        card.querySelector('.dfrev-name').textContent = rv.n + (rv.v ? '  ·  ✓' : '');
        card.querySelector('.dfrev-text').textContent = '“' + rv.t + '”';
        rail.appendChild(card);
      });
    }
    /* avance infinito: anima -1 card, luego mueve la 1ª al final y resetea sin transición (sin saltos, sin fin) */
    function advanceRev() {
      if (revPool.length < 2 || !rail || revAnimating) return;
      revAnimating = true;
      rail.style.transition = 'transform .6s cubic-bezier(.22,1,.36,1)';
      rail.style.transform = 'translateX(' + (-STEP) + 'px)';
      var fired = false;
      var done = function (e) {
        if (e && e.propertyName && e.propertyName !== 'transform') return;
        if (fired) return; fired = true;
        clearTimeout(fb);
        rail.removeEventListener('transitionend', done);
        rail.style.transition = 'none';
        if (rail.firstElementChild) rail.appendChild(rail.firstElementChild);
        rail.style.transform = 'translateX(0)';
        void rail.offsetWidth; /* fuerza reflow para que el siguiente avance vuelva a animar */
        revAnimating = false;
      };
      rail.addEventListener('transitionend', done);
      var fb = setTimeout(done, 720); /* fallback si transitionend no dispara */
    }
    if (nextBtn) nextBtn.addEventListener('click', advanceRev);
    if (typeof REVIEWS !== 'undefined' && REVIEWS) buildRevCards(REVIEWS);
    else fetch(CFG.reviewsUrl).then(function (r) { return r.json(); }).then(buildRevCards).catch(function () {});
    setInterval(function () { advanceRev(); }, 7000);

    /* VERDAD — detalle minimal arriba a la derecha, rota suave */
    if (mVerdad && VERDAD.length) {
      mVerdad.innerHTML = '<span class="dfv-eyebrow">El agua que no ves</span><p class="dfv-text"></p>';
      var vEl = mVerdad.querySelector('.dfv-text'), verIdx = 0;
      vEl.textContent = VERDAD[0];
      setInterval(function () {
        verIdx++;
        vEl.style.opacity = '0';
        setTimeout(function () { vEl.textContent = VERDAD[verIdx % VERDAD.length]; vEl.style.opacity = '1'; }, 600);
      }, 5500);
    }
  })();

  /* ── modelo 3D real (model-viewer): toggle Ver Filtro / Ver Tecnología (estilo iyo) ── */
  (function () {
    var mv = $('#agcMv'), stage = $('#agc3d');
    var toggle = $('#agcViewToggle'), dock = $('#agcViewDock'), hint = $('#agc3dHint');
    if (!mv || !stage || !toggle) return;
    var MODELS = CFG.models3d || {};
    var active = false, subMode = 'filtro', loadedColor = null, raf = null, hintTimer = null;

    function showHint() {
      if (!hint) return;
      hint.classList.remove('show'); void hint.offsetWidth; hint.classList.add('show');
      if (hintTimer) clearTimeout(hintTimer);
      hintTimer = setTimeout(function () { hint.classList.remove('show'); }, 4200);
    }
    function hideHint() { if (hint) hint.classList.remove('show'); if (hintTimer) { clearTimeout(hintTimer); hintTimer = null; } }
    mv.addEventListener('camera-change', function (e) { if (e.detail && e.detail.source === 'user-interaction') hideHint(); });

    function cancelAnims() { if (raf) cancelAnimationFrame(raf); raf = null; }
    function watchUntil(stopAt, after) {
      cancelAnimationFrame(raf);
      var w = function () { if (mv.currentTime >= stopAt - 0.03) { mv.pause(); after && after(); return; } raf = requestAnimationFrame(w); };
      raf = requestAnimationFrame(w);
    }
    /* auto-rotate (built-in) da la vida en reposo; se pausa al tocar y se reanuda tras el delay */
    function autoRotate(on) { if (on) mv.setAttribute('auto-rotate', ''); else mv.removeAttribute('auto-rotate'); }
    function closeHots() { mv.querySelectorAll('.agc-hot.open').forEach(function (h) { h.classList.remove('open'); }); }
    /* modelo normal cerrado — gira/zoom libre + auto-rotate idle */
    function showNormal() {
      cancelAnims(); mv.classList.remove('tech'); closeHots(); mv.setAttribute('shadow-intensity', '0.55');
      try { mv.animationName = 'abrir'; } catch (e) {}
      mv.currentTime = 0; mv.pause();
      mv.cameraTarget = '0m -0.05m 0m'; mv.cameraOrbit = '38deg 60deg 1.08m'; autoRotate(true);
    }
    function playFiltro() {
      cancelAnims(); mv.classList.remove('tech'); closeHots(); mv.setAttribute('shadow-intensity', '0.55');
      try { mv.animationName = 'abrir'; } catch (e) {}
      mv.currentTime = 0; mv.cameraTarget = '0m -0.14m 0m'; mv.cameraOrbit = '28deg 80deg 1.2m'; autoRotate(false);
      mv.play(); watchUntil(2.5, function () { mv.pause(); autoRotate(true); });
    }
    function playTech() {
      cancelAnims(); mv.setAttribute('shadow-intensity', '0');
      try { mv.animationName = 'tecnologia'; } catch (e) {}
      mv.currentTime = 0; mv.cameraTarget = '-0.004m -0.135m 0m'; mv.cameraOrbit = '40deg 86deg 0.92m'; autoRotate(false);
      mv.play(); watchUntil(2.3, function () { mv.pause(); mv.classList.add('tech'); if (mv.jumpCameraToGoal) mv.jumpCameraToGoal(); autoRotate(false); });  /* zoom in + queda FIJA en la posición centrada (ref Pedro); el usuario gira manual si quiere */
    }
    function applySub() { if (subMode === 'filtro') playFiltro(); else if (subMode === 'tech') playTech(); else showNormal(); }
    /* SPEED (2026-07-02): model-viewer se carga LAZY on-tap del 3D (self-host), no eager — port del patrón de ducha (agc-cfg.js). Idempotente vía window.__mvP. */
    function ensureMV(cb) {
      if (window.customElements && customElements.get('model-viewer')) { cb && cb(); return; }
      if (!window.__mvP) { window.__mvP = new Promise(function (res) { var sc = document.createElement('script'); sc.type = 'module'; sc.src = CFG.mvUrl; sc.onload = res; sc.onerror = res; document.head.appendChild(sc); }); }
      window.__mvP.then(function () { cb && cb(); });
    }
    function ensureModel(cb) {
      var url = MODELS[state.colorKey];
      if (!url) { cb && cb(); return; }
      if (loadedColor === state.colorKey && mv.loaded) { cb && cb(); return; }
      var onLoad = function () { mv.removeEventListener('load', onLoad); loadedColor = state.colorKey; cb && cb(); };
      if (mv.getAttribute('src') !== url) { mv.addEventListener('load', onLoad); mv.src = url; }
      else if (mv.loaded) { loadedColor = state.colorKey; cb && cb(); }
      else { mv.addEventListener('load', onLoad); }
    }
    function setToggle() { toggle.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-view') === (active ? '3d' : '2d')); }); }
    function setDock() { if (!dock) return; dock.querySelectorAll('button').forEach(function (b) { b.classList.toggle('on', active && b.getAttribute('data-mode') === subMode); }); }
    function open3d() {
      if (active) return;
      active = true; subMode = 'filtro';
      root.classList.add('show-3d'); closeMenu(); setIsland(false);
      stage.hidden = false; requestAnimationFrame(function () { stage.classList.add('show'); });
      showHint();
      /* parity ducha: en vista 3D, bloquear el scroll de página (no scrollear a la historia) */
      var d3 = document.documentElement, b3 = document.body;
      d3.style.setProperty('overflow', 'hidden', 'important'); b3.style.setProperty('overflow', 'hidden', 'important');
      setToggle(); setDock(); ensureMV(function () { ensureModel(applySub); });
    }
    function close3d() {
      active = false; subMode = 'filtro'; cancelAnims(); mv.classList.remove('tech'); closeHots(); hideHint();
      root.classList.remove('show-3d'); stage.classList.remove('show');
      if (document.getElementById('agc-landing')) { var d3=document.documentElement, b3=document.body; d3.style.setProperty('overflow', 'visible', 'important'); b3.style.setProperty('overflow', 'visible', 'important'); }
      setTimeout(function () { if (!active) stage.hidden = true; }, 560);
      setToggle(); setDock();
    }
    function setSub(m) {
      if (!active || subMode === m) return;   /* selección directa (Modelo / Filtro / Tecnología) */
      subMode = m;
      setDock(); applySub();
    }
    toggle.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { if (b.getAttribute('data-view') === '3d') open3d(); else close3d(); });
    });
    if (dock) dock.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { setSub(b.getAttribute('data-mode')); });
    });
    /* tap-to-reveal: tocar un dot revela su nombre y cierra los demás */
    mv.querySelectorAll('.agc-hot').forEach(function (h) {
      h.addEventListener('click', function (e) { e.stopPropagation(); var was = h.classList.contains('open'); closeHots(); if (!was) h.classList.add('open'); });
    });
    window.__agc3dSync = function () { if (active) ensureMV(function () { ensureModel(applySub); }); };
    /* salir del 3D al abrir la card (reset de fondo a imagen) — close3d NO toca la isla */
    window.__agc3dExit = function () { if (active) close3d(); };
  })();

  /* ── interacción isla (CTA de dos tiempos: Comprar ahora → expandir → Agregar) ── */
  var island = $('#agcIsland');
  function islandOpen() { return island.classList.contains('open'); }
  function inCart() { return island.classList.contains('cart'); }
  /* modos: 'collapsed' | 'config' | 'cart' */
  function setMode(mode) {
    if (mode !== 'collapsed' && window.__agc3dExit) window.__agc3dExit();  /* abrir card → fondo vuelve a imagen */
    island.classList.toggle('open', mode !== 'collapsed');
    island.classList.toggle('cart', mode === 'cart');
    root.classList.toggle('cfg-open', mode !== 'collapsed');
    document.documentElement.classList.toggle('agc-cfgopen', mode !== 'collapsed'); /* barra compartida se oculta al expandir la card */
    /* parity ducha: cart congela el scroll; al salir (con landing embebido) se restaura el scroll de documento */
    var d = document.documentElement, b = document.body;
    if (mode === 'cart') {
      window.scrollTo(0, 0);
      d.style.setProperty('overflow', 'hidden', 'important'); b.style.setProperty('overflow', 'hidden', 'important');
    } else if (document.getElementById('agc-landing') && !root.classList.contains('show-3d')) {
      d.style.setProperty('overflow', 'visible', 'important'); b.style.setProperty('overflow', 'visible', 'important');
    }
    setStep('config');   /* cualquier cambio de modo sale del step Care (parity ducha) */
    updateCta();
    placeAnnBar();
  }
  /* STEP machinery (parity ducha 2026-07-02): config → care → checkout. El CSS de agc-step-care oculta el resto de la card. */
  function setStep(step) {
    state.step = step;
    root.classList.toggle('agc-step-care', step === 'care');
  }
  function setIsland(open) { setMode(open ? 'config' : 'collapsed'); }
  /* CTA con crossfade de copy (transición Apple) */
  function setCtaLabel(html) {
    var label = $('#agcCtaLabel');
    if (!label) return;
    if (label.dataset.cur === html) { return; }
    label.dataset.cur = html;
    label.style.transition = 'opacity .18s ease';
    label.style.opacity = '0';
    setTimeout(function () { label.innerHTML = html; if (!inCart()) render(); label.style.opacity = '1'; }, 180);
  }
  function updateCta() {
    var btn = $('#agcAddBtn');
    if (inCart()) { if (btn) btn.classList.remove('is-soldout'); setCtaLabel('Finalizar pedido'); return; }
    /* el ATC se inhabilita SOLO con la card abierta y color agotado; "Comprar ahora" nunca se bloquea */
    if (islandOpen() && colorSoldOut()) {
      if (btn) btn.classList.add('is-soldout');
      setCtaLabel('Agotado&nbsp;&nbsp;→&nbsp;&nbsp;Elige otro color');
      return;
    }
    if (btn) btn.classList.remove('is-soldout');
    if (islandOpen()) setCtaLabel('Finalizar pedido');
    else setCtaLabel('Comprar ahora');
  }
  $('#agcCfgRow').addEventListener('click', function () {
    closeMenu();
    setMode(islandOpen() ? 'collapsed' : 'config');
  });
  var cartBack = $('#agcCartBack');
  if (cartBack) cartBack.addEventListener('click', function () { setMode('config'); });
  /* icono carrito del nav → abre el cart-morph si hay items */
  var navCart = $('#agcNavCart');
  if (navCart) navCart.addEventListener('click', function (e) {
    e.preventDefault();
    closeMenu();
    getCart().then(function (cart) {
      if (cart.item_count > 0) { renderCart(cart); loadTapeteSheet(); setMode('cart'); startCartBar(); }
      else { setMode('config'); }
    }).catch(function () { window.location.href = '/cart'; });
  });
  /* hook para la barra compartida agc-nav: el icono de carrito abre el cart-morph (no navega a /cart) */
  window.AGCNavCart = function () {
    getCart().then(function (cart) {
      if (cart.item_count > 0) { renderCart(cart); loadTapeteSheet(); setMode('cart'); startCartBar(); }
      else { setMode('config'); }
    }).catch(function () { window.location.href = '/cart'; });
    return true;
  };

  /* v2: selector por baños (misma lógica visual que la ducha) */
  var tiersEl = $('#agcTiers');
  if (tiersEl) tiersEl.addEventListener('click', function (e) {
    var o = e.target.closest('.agc-opt[data-qty]'); if (!o) return;
    $$('.agc-opt[data-qty]').forEach(function (x) { x.classList.remove('on'); });
    o.classList.add('on');
    state.qty = +o.dataset.qty || 1;
    render();
  });
  var subIn = document.getElementById('agcSubSwIn');
  if (subIn) subIn.addEventListener('change', function () { state.plus = !!subIn.checked; render(); });
  var freqsEl = $('#agcFreqs');
  if (freqsEl) freqsEl.addEventListener('click', function (e) {
    var o = e.target.closest('.agc-opt'); if (!o) return;
    $$('.agc-opt[data-freq]').forEach(function (x) { x.classList.remove('on'); });
    o.classList.add('on');
    state.freq = +o.dataset.freq;
    state.planId = PLANS[state.freq] || CFG.sellingPlanId || state.planId;
    render();
  });

  /* cambio de color compartido (isla + color pill) — agotados SÍ seleccionables */
  function colorSoldOut() { var c = colorByKey(state.colorKey); return c && !c.available; }
  function selectColor(key) {
    var c = colorByKey(key);
    if (!c) return;
    state.colorKey = key;
    syncThumb();              /* actualiza thumb + .on de las swatches de la isla */
    setHeroColor(key);        /* swap del strip + tinte SIN reiniciar la animación */
    render();
    $$(".agc-cpsw").forEach(function (x) { x.classList.toggle("on", x.dataset.c === key); });
    syncSoldPill();
    updateCta();
    if (window.__agc3dSync) window.__agc3dSync();   /* si el 3D está activo, recargar el GLB del color */
  }
  var swatchesEl = $('#agcSwatches');
  if (swatchesEl) swatchesEl.addEventListener('click', function (e) {
    var s = e.target.closest('.agc-sw'); if (!s) return;
    selectColor(s.dataset.c);
  });
  var colorPill = $('#agcColorPill');
  if (colorPill) colorPill.addEventListener('click', function (e) {
    var b = e.target.closest('.agc-cpsw'); if (!b) return;
    selectColor(b.dataset.c);
  });

  function syncSoldPill() {
    var sold = colorSoldOut();
    root.classList.toggle("is-soldout", sold);
    if (sold) {
      var c = colorByKey(state.colorKey);
      var span = document.querySelector('#agcSoldPill span');
      if (span && c) span.textContent = (c.name.split(' ')[0]) + ' agotado';
    }
  }

  /* ═══════════════ CART ENGINE (cart-morph) ═══════════════ */
  var CC = CFG.cart || {};
  var LASTCART = null;
  function jpost(url, body) {
    /* rechaza en !ok (Pedro 2026-07-02): antes un 422 de cart/add "resolvía" → redirect a checkout con cart vacío → Shopify rebotaba a homepage */
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) {
        if (!r.ok) { return r.json().catch(function () { return {}; }).then(function (e) { e = e || {}; e.status = r.status; throw e; }); }
        return r.json();
      });
  }
  function getCart() { return fetch('/cart.js').then(function (r) { return r.json(); }); }
  function refreshCount() {
    getCart().then(function (c) { var el = $('#agcCartCount'); if (el) el.textContent = c.item_count; }).catch(function () {});
  }

  /* compare-at por item (hardcodes verificados del live) */
  function itemCompare(it) {
    if (it.product_id === CFG.duchaProductId) return CC.duchaCompareUnit * it.quantity;
    if (it.variant_id === CC.annualVariant) return CC.annualCompare * it.quantity;
    if (it.variant_id === CC.careVariant) return CC.careCompare * it.quantity;
    if (it.product_id === CC.tapeteProductId) return CC.tapeteCompare * it.quantity;
    return it.original_line_price;
  }
  function findItem(cart, pred) {
    for (var i = 0; i < cart.items.length; i++) if (pred(cart.items[i])) return cart.items[i];
    return null;
  }
  function duchaQty(cart) {
    var q = 0;
    cart.items.forEach(function (it) { if (it.product_id === CFG.duchaProductId && it.original_price !== 0) q += it.quantity; });
    return q;
  }

  /* render de una línea de carrito (glass) */
  function cartItemRow(it) {
    var el = document.createElement('div');
    el.className = 'agc-citem';
    el.setAttribute('data-key', it.key);
    var compare = itemCompare(it);
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$2') : (it.featured_image && it.featured_image.url) || '';
    /* ducha usa el render limpio del color elegido */
    var isDucha = it.product_id === CFG.duchaProductId;
    /* en el carrito la ducha conserva la foto con fondo cream (cartImg), no el render transparente */
    if (isDucha) { var cc = colorByKey(state.colorKey); if (cc && (cc.cartImg || cc.img)) img = cc.cartImg || cc.img; }
    var sub = '';
    if (isDucha) {
      var cname = (it.options_with_values && it.options_with_values[0] && it.options_with_values[0].value) || colorByKey(state.colorKey).name;
      sub = cname + (it.selling_plan_allocation ? ' · ' + it.selling_plan_allocation.selling_plan.name : '');
    } else if (it.selling_plan_allocation) {
      sub = it.selling_plan_allocation.selling_plan.name;
    } else if (it.variant_title && it.variant_title !== 'Default Title') {
      sub = it.variant_title;
    }
    var priceHtml = '<b>' + fmt(it.final_line_price) + '</b>' + (compare > it.final_line_price ? '<s>' + fmt(compare) + '</s>' : '');
    el.innerHTML =
      '<div class="agc-cithumb">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</div>' +
      '<div class="agc-citinfo">' +
        '<div class="agc-cittitle">' + (it.product_title || it.title) + '</div>' +
        (sub ? '<div class="agc-citsub">' + sub + '</div>' : '') +
      '</div>' +
      '<div class="agc-citright">' +
        '<div class="agc-citprice">' + priceHtml + '</div>' +
        '<div class="agc-citqtyrow">' +
          '<div class="agc-citqty"><button class="m" data-act="dec" aria-label="Restar">−</button><span>' + it.quantity + '</span><button class="p" data-act="inc" aria-label="Sumar">+</button></div>' +
          '<button class="agc-citrm" data-act="rm" aria-label="Quitar"><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"><path d="M4 7h16M9 7V5h6v2m1 0-1 13H8L7 7"/></svg></button>' +
        '</div>' +
      '</div>';
    return el;
  }

  function renderCart(cart) {
    LASTCART = cart;
    var dq = duchaQty(cart);
    var hasAnnual = !!findItem(cart, function (i) { return i.variant_id === CC.annualVariant; });
    var hasCare = !!findItem(cart, function (i) { return i.variant_id === CC.careVariant; });
    var hasTapete = !!findItem(cart, function (i) { return i.product_id === CC.tapeteProductId; });

    /* líneas: ducha + annual + tapete (care y demás extras no se listan, viven en cross-sell) */
    var grid = $('#agcCartItems');
    grid.innerHTML = '';
    cart.items.forEach(function (it) {
      if (it.variant_id === CC.careVariant) return; /* care = toggle, no línea */
      grid.appendChild(cartItemRow(it));
    });

    /* tier row activo según qty de ducha */
    $$('#agcCartTiers .agc-ctier').forEach(function (b) { b.classList.toggle('on', +b.dataset.tier === dq); });

    /* cross-sell visibility */
    var xAnnual = $('#agcXAnnual');
    if (xAnnual) xAnnual.hidden = !(dq >= 1 && !hasAnnual);
    var xTapete = $('#agcXTapete');
    if (xTapete) xTapete.hidden = hasTapete;
    /* Care: al agregarlo la card DESAPARECE y aparecen las líneas de garantía */
    var xCare = $('#agcXCare');
    if (xCare) xCare.hidden = hasCare;
    var careToggle = $('#agcXCareToggle');
    if (careToggle) { careToggle.classList.toggle('on', hasCare); careToggle.setAttribute('aria-checked', hasCare ? 'true' : 'false'); }
    $$('.agc-ct-care').forEach(function (r) { r.hidden = !hasCare; });
    var warr = $('#agcCtWarr'); if (warr) { warr.textContent = hasCare ? '100 días' : '60 días'; warr.classList.toggle('agc-ct-on', hasCare); }

    /* totales */
    var compareTotal = 0;
    cart.items.forEach(function (it) { compareTotal += itemCompare(it); });
    $('#agcCtCount').textContent = cart.item_count;
    $('#agcCtSubFinal').textContent = fmt(cart.total_price);
    var sc = $('#agcCtSubCompare');
    if (compareTotal > cart.total_price) { sc.textContent = fmt(compareTotal); sc.style.display = ''; }
    else { sc.style.display = 'none'; }

    var headN = $('#agcCartHeadN'); if (headN) headN.textContent = cart.item_count + (cart.item_count === 1 ? ' artículo' : ' artículos');
    var cnt = $('#agcCartCount'); if (cnt) cnt.textContent = cart.item_count;
  }

  function reloadCart() { return getCart().then(renderCart); }

  /* mutaciones */
  function cartChange(key, qty) {
    return jpost('/cart/change.js', { id: key, quantity: qty }).then(renderCart);
  }
  /* tier: setea la cantidad de la línea ducha */
  function setTier(n) {
    if (!LASTCART) return;
    var d = findItem(LASTCART, function (i) { return i.product_id === CFG.duchaProductId && i.original_price !== 0; });
    if (!d) return;
    state.tier = n;
    cartChange(d.key, n);
  }

  /* eventos del carrito (delegación) */
  $('#agcCartItems').addEventListener('click', function (e) {
    var btn = e.target.closest('[data-act]'); if (!btn) return;
    var row = btn.closest('.agc-citem'); if (!row) return;
    var key = row.getAttribute('data-key');
    var item = findItem(LASTCART, function (i) { return i.key === key; });
    if (!item) return;
    var act = btn.dataset.act;
    if (act === 'rm') cartChange(key, 0);
    else if (act === 'dec') cartChange(key, Math.max(0, item.quantity - 1));
    else if (act === 'inc') cartChange(key, item.quantity + 1);
  });
  $('#agcCartTiers').addEventListener('click', function (e) {
    var b = e.target.closest('.agc-ctier'); if (!b) return;
    setTier(+b.dataset.tier);
  });

  /* cross-sell: Set Anual */
  var xAnnualBtn = $('#agcXAnnualBtn');
  if (xAnnualBtn) xAnnualBtn.addEventListener('click', function () {
    xAnnualBtn.setAttribute('disabled', '');
    jpost('/cart/add.js', { items: [{ id: CC.annualVariant, quantity: 1 }] })
      .then(reloadCart).then(function () { xAnnualBtn.removeAttribute('disabled'); xAnnualBtn.textContent = 'Agregar'; })
      .catch(function () { xAnnualBtn.removeAttribute('disabled'); });
  });

  /* cross-sell: Aguacero Care (opt-in toggle, sin auto-add) */
  var careToggle = $('#agcXCareToggle');
  if (careToggle) careToggle.addEventListener('click', function () {
    var on = careToggle.classList.contains('on');
    if (on) {
      var c = findItem(LASTCART, function (i) { return i.variant_id === CC.careVariant; });
      if (c) cartChange(c.key, 0);
    } else {
      jpost('/cart/add.js', { items: [{ id: CC.careVariant, quantity: 1 }] }).then(reloadCart);
    }
  });
  var careRemove = $('#agcCtCareRemove');
  if (careRemove) careRemove.addEventListener('click', function () {
    var c = findItem(LASTCART, function (i) { return i.variant_id === CC.careVariant; });
    if (c) cartChange(c.key, 0);
  });

  /* cross-sell: Tapete (sheet de detalles) */
  var TAP_IMGS = null;
  function loadTapeteSheet() {
    var box = $('#agcTapImgs');
    if (TAP_IMGS) return;
    fetch('/products/' + CC.tapeteHandle + '.js').then(function (r) { return r.json(); }).then(function (p) {
      TAP_IMGS = (p.images || []).slice(0, 5).map(function (u) { return u.indexOf('//') === 0 ? 'https:' + u : u; });
      box.innerHTML = TAP_IMGS.map(function (u) { return '<img src="' + u + '&width=560" alt="" loading="lazy">'; }).join('');
      var th = $('#agcXTapeteThumb');
      if (th && TAP_IMGS[0]) th.innerHTML = '<img src="' + TAP_IMGS[0] + '&width=120" alt="" loading="lazy">';
      var pr = $('#agcTapPrice'); if (pr && p.price) pr.textContent = fmt(p.price);
    }).catch(function () {});
  }
  function openTapeteOrCare(which) {
    var ov = $('#agcTapSheet');
    if (ov) ov.classList.add('show');
  }
  var xTapBtn = $('#agcXTapeteBtn');
  if (xTapBtn) xTapBtn.addEventListener('click', function () { openTapeteOrCare('tapete'); });
  var tapClose = $('#agcTapClose');
  if (tapClose) tapClose.addEventListener('click', function () { $('#agcTapSheet').classList.remove('show'); });
  var tapOv = $('#agcTapSheet');
  if (tapOv) tapOv.addEventListener('click', function (e) { if (e.target === tapOv) tapOv.classList.remove('show'); });
  var tapAdd = $('#agcTapAdd');
  if (tapAdd) tapAdd.addEventListener('click', function () {
    tapAdd.setAttribute('disabled', '');
    jpost('/cart/add.js', { items: [{ id: CC.tapeteVariant, quantity: 1 }] })
      .then(reloadCart).then(function () { $('#agcTapSheet').classList.remove('show'); tapAdd.removeAttribute('disabled'); })
      .catch(function () { tapAdd.removeAttribute('disabled'); });
  });

  /* barra social rotativa del carrito */
  var cbIdx = 0, cbTimer = null;
  function startCartBar() {
    var items = $$('#agcCartBar span');
    if (!items.length || cbTimer) return;
    cbTimer = setInterval(function () {
      items[cbIdx].classList.remove('on');
      cbIdx = (cbIdx + 1) % items.length;
      items[cbIdx].classList.add('on');
    }, 5000);
  }
  function stopCartBar() { if (cbTimer) { clearInterval(cbTimer); cbTimer = null; } }

  /* ── CTA principal (parity ducha 2026-07-02): collapsed→config, config→STEP Care (pantalla del flujo),
     checkout SOLO desde los botones del step. Sin cart island en el flujo de compra. ── */
  $('#agcAddBtn').addEventListener('click', function () {
    if (state.busy) return;
    if (inCart()) { checkoutOrCare(); return; }   /* cart island (icono nav) → mismo gate que ducha */
    /* fuera de la primera pantalla (footer-only): "Comprar ahora" regresa arriba Y abre la card (1 solo click) */
    if (root.classList.contains('scrolled') && !islandOpen()) { closeMenu(); if (window.__agcLenis) window.__agcLenis.scrollTo(0); else scroller.scrollTo({ top: 0, behavior: 'smooth' }); setMode('config'); return; }
    /* "Comprar ahora" SIEMPRE expande la card (nunca se bloquea) */
    if (!islandOpen()) { closeMenu(); setMode('config'); return; }
    if (colorSoldOut()) {
      var availC = CFG.colors.filter(function (x) { return x.available; })[0];
      if (availC) selectColor(availC.key);
      return;
    }
    /* v2 (Pedro 2026-09-23): sin paso de Care; directo al pago */
    var _btn = $('#agcAddBtn'); if (_btn) _btn.classList.add('is-busy');
    proceedCheckoutF(false);
  });

  /* ATC + checkout factorizado (parity ducha). addCare = agregar Aguacero Care PAGADO desde el step.
     DETERMINISTA (Pedro 2026-07-02: "llegué a checkout con ambos"): el clear de pageshow es best-effort
     (bfcache iOS / 429 silencioso pueden saltárselo) → aquí se hace CLEAR+ADD en la misma acción, así el
     checkout SIEMPRE lleva exactamente lo configurado en esta pasada, nunca acumulado. */
  function proceedCheckoutF(addCare) {
    state.busy = true;
    var c = colorByKey(state.colorKey);
    var addItem = { id: c.variantId, quantity: state.qty };
    var plan3 = PLANS[3] || state.planId;
    if (state.plus && plan3) addItem.selling_plan = plan3;   /* switch apagado = compra única */
    var items = [addItem];
    if (addCare && CC.careVariant) items.push({ id: Number(CC.careVariant), quantity: 1 });
    jpost('/cart/clear.js', {})
      .catch(function () {})   /* si el clear falla seguimos: peor caso = comportamiento anterior */
      .then(function () { return jpost('/cart/add.js', { items: items }); })
      /* F35 PIXEL: commit de atribución entre el add exitoso y el redirect. Fail-open: nunca bloquea la venta. */
      .then(function () { return window.AGCAttr ? AGCAttr.beforeCheckout().catch(function () {}) : Promise.resolve(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function (err) {
        console.error('[AGC-CFG] add error', err);
        state.busy = false;
        var y = $('#agcCareStepYes'), n = $('#agcCareStepNo');
        var ab = $('#agcAddBtn'); if (ab) ab.classList.remove('is-busy');
        if (y) y.classList.remove('is-busy');
        if (n) n.classList.remove('is-busy');
      });
  }
  /* Step Care: sus propios botones */
  (function () {
    var yes = $('#agcCareStepYes'), no = $('#agcCareStepNo'), back = $('#agcCareStepBack');
    if (yes) yes.addEventListener('click', function () { if (state.busy) return; yes.classList.add('is-busy'); proceedCheckoutF(true); });
    if (no) no.addEventListener('click', function () { if (state.busy) return; no.classList.add('is-busy'); proceedCheckoutF(false); });
    if (back) back.addEventListener('click', function () { setStep('config'); });
  })();
  /* DIRECT-CHECKOUT (parity ducha 2026-07-02): el cart es EFÍMERO (solo vehículo a checkout). Se vacía
     cada vez que se MUESTRA la página (carga inicial + "back" del checkout — pageshow cubre ambos, incl.
     bfcache de webviews in-app Meta/IG) y se ponen en 0 AMBOS badges. Así si regresan del checkout a
     cambiar el plan/meses, el siguiente "Finalizar pedido" arma el cart fresco — nunca acumula. */
  window.addEventListener('pageshow', function () {
    /* reset del CTA: el bfcache restaura el DOM tal cual (botón disabled + label viejo + busy) — destrabar */
    state.busy = false;
    var _b = $('#agcAddBtn'); if (_b) _b.removeAttribute('disabled');
    var _l = $('#agcCtaLabel'); if (_l) { _l.style.opacity = '1'; _l.dataset.cur = ''; }
    try { updateCta(); } catch (x) {}
    var _cy = $('#agcCareStepYes'); if (_cy) _cy.classList.remove('is-busy');
    var _cn = $('#agcCareStepNo'); if (_cn) _cn.classList.remove('is-busy');
    jpost('/cart/clear.js', {}).then(function () {
      document.querySelectorAll('#agcCartCount, [data-agcn-count]').forEach(function (el) { el.textContent = '0'; });
      try { reloadCart(); } catch (x) {}
    }).catch(function () {});
  });

  /* ── CARE GATE (parity ducha 2026-07-02): un solo paso Care → checkout directo, sin cart island en el flujo de compra.
     El overlay vive en body (fixed, z-100000) — patrón idéntico a agc-cfg.js. ── */
  var careOverlay = (function () {
    var ov = document.getElementById('agcCfgCareOverlay');
    if (ov && ov.parentElement !== document.body) document.body.appendChild(ov);
    return ov;
  })();
  /* F35 PIXEL: única salida a checkout del gate cart-island — commit de atribución y luego navegar. Fail-open: si el pixel no existe o falla, la venta sigue igual. */
  function _agcPxGo() {
    return (window.AGCAttr ? AGCAttr.beforeCheckout().catch(function () {}) : Promise.resolve())
      .then(function () { window.location.href = '/checkout'; });
  }
  function checkoutOrCare() {
    getCart().then(function (cart) {
      var hasCare = cart.items.some(function (i) { return i.variant_id === CC.careVariant; });
      if (hasCare) { _agcPxGo(); return; }
      var ov = careOverlay || document.getElementById('agcCfgCareOverlay');
      if (!ov) { _agcPxGo(); return; }
      ov.classList.add('show'); ov.setAttribute('aria-hidden', 'false');
    }).catch(function () { _agcPxGo(); });
  }
  (function () {
    var ov = careOverlay; if (!ov) return;
    function closeCare() { ov.classList.remove('show'); ov.setAttribute('aria-hidden', 'true'); }
    var yes = ov.querySelector('#agcCfgCareYes'), no = ov.querySelector('#agcCfgCareNo');
    if (yes) yes.addEventListener('click', function () {
      yes.disabled = true; yes.textContent = 'Agregando…';
      jpost('/cart/add.js', { items: [{ id: CC.careVariant, quantity: 1 }] })
        .then(function () { _agcPxGo(); })
        .catch(function () { _agcPxGo(); });
    });
    if (no) no.addEventListener('click', function () { _agcPxGo(); });
    var x = ov.querySelector('#agcCfgCareX'); if (x) x.addEventListener('click', closeCare);
    ov.addEventListener('click', function (e) { if (e.target === ov) closeCare(); });
  })();

  /* ── EMBED KIT (parity ducha 2026-07-02) ── */
  /* Announcement bar: cicla mensajes con crossfade+blur. Pace premium 4s. */
  (function () {
    var bar = $('#agcAnnBar');
    if (!bar) return;
    var msgs = bar.querySelectorAll('.agc-annbar-msg');
    if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('on');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('on');
    }, 4000);
  })();
  /* placeAnnBar (versión filtro, sin revzone): collapsed = arriba (CSS); open = anclado 12px sobre el card */
  var annRaf = 0;
  function placeAnnBar() {
    var bar = $('#agcAnnBar'); if (!bar) return;
    cancelAnimationFrame(annRaf);
    if (island.classList.contains('open')) {
      bar.classList.add('is-oncard');
      bar.style.top = 'auto';
      var t0 = (window.performance && performance.now) ? performance.now() : Date.now();
      (function follow() {
        var r = island.getBoundingClientRect();
        bar.style.left = Math.round(r.left + r.width / 2) + 'px';
        bar.style.bottom = Math.round(window.innerHeight - r.top + 12) + 'px';
        var now = (window.performance && performance.now) ? performance.now() : Date.now();
        if (now - t0 < 1000) annRaf = requestAnimationFrame(follow);
      })();
    } else {
      bar.style.top = ''; bar.style.bottom = ''; bar.style.left = '';
      bar.classList.remove('is-oncard');
    }
  }
  placeAnnBar();
  /* Volver al configurador (loop + CTA glass) */
  window.AGCReturnToConfig = function () {
    if (window.__agcLenis) window.__agcLenis.scrollTo(0); else window.scrollTo({ top: 0, behavior: 'smooth' });
    if (scroller) scroller.scrollTo({ top: 0, behavior: 'smooth' });
    setMode('config');
  };
  var backTopBtn = document.getElementById('agcBackTop');
  var loopArmed = false, loopT = 0;
  if (backTopBtn) {
    var btRaf = 0;
    function btUpd() {
      btRaf = 0;
      var y = window.scrollY || window.pageYOffset || 0;
      backTopBtn.classList.toggle('show', y > innerHeight * 0.6);
      var atBottom = (y + innerHeight) >= (document.documentElement.scrollHeight - 6);
      if (atBottom) {
        if (!loopArmed) {
          loopArmed = true;
          clearTimeout(loopT);
          loopT = setTimeout(function () { if (loopArmed) { loopArmed = false; window.AGCReturnToConfig(); } }, 420);
        }
      } else { loopArmed = false; clearTimeout(loopT); }
    }
    window.addEventListener('scroll', function () { if (!btRaf) btRaf = requestAnimationFrame(btUpd); }, { passive: true });
    btUpd();
    backTopBtn.addEventListener('click', function () { window.AGCReturnToConfig(); });
  }

  buildStrip(state.colorKey);
  setHeroColor(state.colorKey);
  syncThumb();
  syncSoldPill();
  render();
  refreshCount();
})();
